import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconSend = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1" y="1" width="18" height="13" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M10 9.23335L9.5088 9.80012C9.7907 10.0444 10.2093 10.0444 10.4912 9.80012L10 9.23335ZM0.508802 2.00012L9.5088 9.80012L10.4912 8.66658L1.4912 0.866583L0.508802 2.00012ZM10.4912 9.80012L19.4912 2.00012L18.5088 0.866583L9.5088 8.66658L10.4912 9.80012Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconSend
